import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useStaticProps, queryParameterContext } from '../../context';

export const FieldOfStudyFilter = () => {
  const fieldsOfStudyFilter = queryParameterContext.useFilterField('fieldsOfStudy', 'PrimaryFilter');
  const {
    referenceData: { fieldsOfStudy },
  } = useStaticProps();

  return (
    <MultiCombobox
      value={fieldsOfStudyFilter.value}
      aria-label="Field of study"
      placeholder="Field of study"
      onChange={(selectedItems) => fieldsOfStudyFilter.setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {Object.entries(fieldsOfStudy).map(([id, { name }]) => (
        <MultiCombobox.Option label={name} value={id} key={id} />
      ))}
    </MultiCombobox>
  );
};
